import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { getCpsMemberEmailEndpoint } from '../../../common/endpoints';

export const getCpsMemberEmailApi = createApi(getCpsMemberEmailEndpoint, 'GET');

const GetCpsMemberEmail = createSlice({
  name: 'GetCpsMemberEmail',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCpsMemberEmailApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCpsMemberEmailApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getCpsMemberEmailApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetCpsMemberEmail.reducer;